'use strict';

import React, { useState, useEffect } from 'react';

// import Stripe from 'stripe'

import { loadStripe } from '@stripe/stripe-js';
import Button from '@material-ui/core/Button';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
export default function TestStripePaymentKit({
  id,
  ...props
}) {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({});
  useEffect(function () {
    setStatus({});
  }, [id, props.sk, props.pk]);
  const loader = loading === true ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['white', 'bg-primary']
  }) : undefined;
  const output = /*#__PURE__*/React.createElement("div", {
    className: "c-form-section u-margin-bottom-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-form-section__title"
  }, "Tester le paiement en direct"), /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-positioned\r u-padding-top-20 u-padding-bottom-10"
  }, /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['primary']),
    onClick: testEtablishment,
    disabled: !id
  }, "Tester la configuration du paiement", loader), status.error ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['red', 'v2'])
  }, /*#__PURE__*/React.createElement("pre", {
    className: "c-message__content"
  }, status.error)) : getFormStatus(status)));
  return output;
  async function testEtablishment(e) {
    if (loading === true || !id) return;
    setLoading(true);
    try {
      var response = await ajaxRequest(action('TestStripePaymentKit'), {
        data: {
          etablishment_id: id,
          sk: props.sk,
          pk: props.pk
        }
      });
    } catch (e) {
      console.error(e);
      setLoading(false);
      return setStatus(e);
    }
    try {
      const stripe = await loadStripe(props.pk);
      const elements = await stripe.elements({
        clientSecret: response.client_secret
      });
      const {
        error
      } = await elements.fetchUpdates();
      if (error) {
        throw error.message || error;
      }
    } catch (e) {
      setLoading(false);
      return setStatus({
        error: typeof e === 'string' ? e : 'Échec de l\'initialisation du paiement.'
      });
    }
    setLoading(false);
    return setStatus(response);
  }
}
